const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/privacy-policy"],
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: ["/contact-us"],
    exact: true,
    component: "Contact",
  },
  {
    path: ["/terms-and-conditions"],
    exact: true,
    component: "TermConditions",
  },
  {
    path: ["/about-us"],
    exact: true,
    component: "AboutUs",
  },
];

export default routes;
